export function AcceptLanguageToTexteLanguage(language: string): number {
  switch (language) {
    default:
    case 'de':
    case 'de-DE':
      return 0;
    case 'en':
    case 'en-US':
      return 1;
    case 'fr':
      return 2;
    case 'it':
      return 3;
  }
}
